
<app-product-cards-landing/>
<!-- my Policy List  -->
<!-- <my-policy-card-list/> -->
<!-- card-2 -->
<!-- <div class="card cardfile">
    <div class="card-body">
        <div class="row">
    <div class="col-12 col-lg-6 col-xl-6 col-md-12 col-xs-12">
        <img src="../assets/images/dewatermark.png" class=""  alt="img" width="100%" height="100%">
    </div>
    <div class="col-12 col-lg-6 col-xl-6 col-md-12 col-xs-12">
        <h4 class="Afrisurecolor fn-30 lineHeight letterspacing2px">Insurance isn't just a necessity, </h4>
        <h1 class="Afrisureheadercolor fn-40 letterspacing2px lineHeight">But an exciting 
            part of daily life</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut sodales urna sed neque consectetur, pharetra eleifend ligula feugiat. Phasellus venenatis pharetra ligula, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut sodales urna sed neque consectetur, </p>
    </div>
</div>
</div>
</div> -->

<!-- card3 -->
<!-- <div class="card cardfile">
    <div class="card-body">
<div><h1 class="Afrisureheadercolor fn-40">Why Afrisure ?</h1></div>
<div class="headerlabel">
    @for(ex of afrisureCards;track ex; let i = $index){
    <div class="card  custom-col-3" [ngClass]="{'Afrisureheadercolor': i % 2 === 0, 'red-border': i % 2 === 1, 'blue-border': i % 2 === 0}">
        <div class="card-body p-3">
            <div class="fn-30 mb-3"><img src="../assets/images/cards/{{ex.icon}}.svg" alt=""></div>
            <mat-label class="card-title fn-28 Afrisureheadercolor lineHeight">{{ex.label}}</mat-label>
            <p class="card-text Afrisurecolor">{{ex.p}}</p>
        </div>
    </div>
}
</div>
</div>
</div>
<div class="card cardfile">
    <div class="card-body">
        <div class="row p-3">
            <div class="col-12 col-lg-6 col-xl-6 col-md-12 col-xs-12">

        <div class="fn-30 mb-3"><img src="../assets/images/cards/spider.svg" alt=""></div>

        <h4 class="Afrisureheadercolor fn-30 letterspacing2px lineHeight">AI Technology for a new generation
             </h4>
                <p class="cologrey">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut sodales urna sed neque consectetur, pharetra eleifend ligula feugiat. Phasellus venenatis pharetra ligula, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut sodales urna sed neque consectetur, </p>
    </div>
    <div class="col-12 col-lg-6 col-xl-6 col-md-12 col-xs-12">
        <img src="../assets/images/AIgeneration.jpg"  alt="img" width="100%" height="100%">
    </div>
</div>
</div>
</div>
<div>
<app-customer-card-landing/>
</div>
<div>
<app-article-card-landing/>
</div>
<div class="col-12 mb-3" >
    <div class="row  ">
        <div class="col-6">
            <h5 class="m-2 p-2 customer-red fn-24" >FAQs</h5>
        </div>
        <div class="col-6 m-0 p-0 d-flex justify-content-end">
            <p class="m-2 p-2 Afrisureheadercolor underline cursor-pointers fn-18" >
                Didn't find what you were looking for ?
            </p>
        </div>
    </div>
    <div class="row border m-0 p-0 mt-3 border-radius">
        <div class="col-11 m-0 p-0">
            <p class="p-2 m-2 Afrisureheadercolor fn-18" >Insurance information</p>
        </div>
        <div class="col-1 m-0 p-0 d-flex justify-content-end align-items-center" >
            <p class="p-2 m-2 Afrisureheadercolor" ><em class="fa-solid fa-chevron-right"></em></p>    
        </div>
    </div>
    <div class="row border m-0 p-0 mt-3 border-radius">
        <div class="col-11 m-0 p-0">
           <p class="p-2 m-2 Afrisureheadercolor fn-18" > Types of Insurance </p>
        </div>
        <div class="col-1 m-0 p-0 d-flex justify-content-end align-items-center" >
            <p class="p-2 m-2 Afrisureheadercolor" ><em class="fa-solid fa-chevron-right"></em></p>    
        </div>
    </div>
    <div class="row border m-0 p-0 mt-3 border-radius">
        <div class="col-11 m-0 p-0">
            <p class="p-2 m-2 Afrisureheadercolor fn-18" >Sell and Buy Gold Faqs</p>
        </div>
        <div class="col-1 m-0 p-0 d-flex justify-content-end align-items-center" >
            <p class="p-2 m-2 Afrisureheadercolor" ><em class="fa-solid fa-chevron-right"></em></p>    
        </div>
    </div>
    <div class="row border m-0 p-0 mt-3 border-radius">
        <div class="col-11 m-0 p-0">
            <p class="p-2 m-2 Afrisureheadercolor fn-18" >Legal</p>
        </div>
        <div class="col-1 m-0 p-0 d-flex justify-content-end align-items-center" >
            <p class="p-2 m-2 Afrisureheadercolor" ><em class="fa-solid fa-chevron-right"></em></p>    
        </div>
    </div> 
    <div class="row border m-0 p-0 mt-3 border-radius">
        <div class="col-11 m-0 p-0">
            <p class="p-2 m-2 Afrisureheadercolor fn-18" >Contact us</p>
        </div>
        <div class="col-1 m-0 p-0 d-flex justify-content-end align-items-center" >
            <p class="p-2 m-2 Afrisureheadercolor" ><em class="fa-solid fa-chevron-right"></em></p>    
        </div>
    </div> 
</div> 
<chatbot/> -->
